import { useMemo } from 'react'
import { withUserContext } from 'context';
import { Text, CustomLink, Image } from 'components/common'
import NotifyItem from './NotifyItem';

import NotificationsStyle from './style'


const Notifications = ({ user, isOpen }) => {

    const storeNotifications = useMemo(() => {
        return user?.notifications?.map(not => <NotifyItem key={not.id} not={not} />)
    }, [user])

    return (
        <NotificationsStyle className={`notifications flexBoxColumn ${isOpen ? 'active' : ''}`}>
            {storeNotifications}
            {user?.notifications?.length > 0 ? <CustomLink url='/notifications'>
                <Text tag='h6' className='see-all PopSemi purple h6' text='See all' />
            </CustomLink> : <Image className='not-found' src='/images/notFound.gif' />
            }
        </NotificationsStyle>
    )
}

export default withUserContext(Notifications, ['user'])
